module.exports = __webpack_public_path__ + "img/sub-nav-links-nissan.84548157.png";